export default {
    initializing(state, payload) {
        state.initializing = payload;
        return state;
    },

    initializingFailed(state, payload) {
        state.initializingFailed = payload;
        return state;
    },

    title(state, payload) {
        state.title = payload;
        return state;
    },

    bootProgress(state, payload) {
        state.bootProgress = payload;
        return state;
    },

    loadingItems(state, payload) {
        state.loadingItems = payload;
        return state;
    },

    everythingLoaded(state, payload) {
        state.everythingLoaded = payload;
        return state;
    },

    navLoaded(state, payload) {
        state.navLoaded = payload;
        return state;
    },

    experienceMarkersLoaded(state, payload) {
        state.experienceMarkersLoaded = payload;
        return state;
    },

    modal(state, payload) {
        state.modal = payload;
        return state;
    },

    auxOpen(state, payload) {
        state.auxOpen = payload;
        return state;
    },

    navOpen(state, payload) {
        state.navOpen = payload;
        return state;
    },

    navOption(state, payload) {
        state.navOption = payload;
        return state;
    },

    prevNavOption(state, payload) {
        state.prevNavOption = payload;
        return state;
    },

    experienceMarker(state, payload) {
        state.experienceMarker = payload;
        return state;
    },

    mapFilter(state, payload) {
        state.mapFilter = payload;
        return state;
    },

    mapBounds(state, payload) {
        state.mapBounds = payload;
        return state;
    },

    renderMapBounds(state, payload) {
        state.renderMapBounds = payload;
        return state;
    },

    geoData(state, payload) {
        state.geoData = payload;
        return state;
    },

    auxMinimized(state, payload) {
        state.auxMinimized = payload;
        return state;
    },

    auxResourceUrl(state, payload) {
        state.auxResourceUrl= payload;
        return state;
    },

    auxResourceName(state, payload) {
        state.auxResourceName= payload;
        return state;
    },

    footerOpen(state, payload) {
        state.footerOpen = payload;
        return state;
    },

};